import { useState } from "react"
import style from "./PlanPricing.module.css"
import pricingData from "../../json/Homepage/PlanPricing.json"

const PlanPricing = () => {
    const [activePlan, setActivePlan] = useState("Monthly")

    return (
        <div className={style.PlanPricingcontainer}>
            <div className="container">
                <div className={style.planandpricing}>
                    <p className={style.orangeeffect}>{`{${pricingData.component}}`}</p>
                    <h1 className={style.plantitle}>{pricingData.title}</h1>
                    <p className={style.plandescription}>{pricingData.description}</p>
                    <div className={style.priceTimeContainer}>
                        <button
                            className={`${style.planButton} ${activePlan === "Monthly" ? style.activePlan : ""}`}
                            onClick={() => setActivePlan("Monthly")}
                        >
                            Monthly
                        </button>
                        <button
                            className={`${style.planButton} ${activePlan === "Annual" ? style.activePlan : ""}`}
                            onClick={() => setActivePlan("Annual")}
                        >
                            Annual
                        </button>
                    </div>
                </div>

                <div className={style.priceCardContainer}>
                    {
                        activePlan === "Monthly" && (<>
                            {pricingData.priceCard.monthly.map((item, index) => (
                                <div key={index} className={item.mostPopular ? style.mostPopularWrapper : ""}>
                                    <p className={item.mostPopular ? style.mostpopularp : ""}>{item.mostPopular ? "Most Popular" : ""}</p>
                                    <div className={`${style.priceCards} ${item.mostPopular ? style.mostPopular : ""}`}>
                                        <div className={style.tagandpricing}>
                                            <div className={style.Planpricecategory}>

                                                <p className={style.priceCategory}>{item.Categories}</p>
                                            </div>

                                            <div className={style.priceAmount}>
                                                <span className={style.currency}>₹</span>
                                                <span className={style.amount}>{item.amount}</span>
                                                <span className={style.period}>INR</span>
                                            </div>

                                            <p className={style.priceDescription}>{item.about}</p>
                                        </div>

                                        <button className={style.priceButton}>{item.button}</button>

                                        <div className={style.priceIncludes}>
                                            <p className={style.includesLabel}>{item.include}</p>
                                            <ul className={style.includesList}>
                                                {item.includes.map((itemdata, idx) => (
                                                    <li key={idx}>{itemdata}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>)
                    }

                    {
                        activePlan === "Annual" && (<>
                            {pricingData.priceCard.yearly.map((item, index) => (
                                <div key={index} className={item.mostPopular ? style.mostPopularWrapper : ""}>
                                    <p className={item.mostPopular ? style.mostpopularp : ""}>{item.mostPopular ? "Most Popular" : ""}</p>
                                    <div className={`${style.priceCards} ${item.mostPopular ? style.mostPopular : ""}`}>
                                        <div className={style.tagandpricing}>
                                            <div className={style.Planpricecategory}>

                                                <p className={style.priceCategory}>{item.Categories}</p>
                                            </div>

                                            <div className={style.priceAmount}>
                                                <span className={style.currency}>₹</span>
                                                <span className={style.amount}>{item.amount}</span>
                                                <span className={style.period}>INR</span>
                                            </div>

                                            <p className={style.priceDescription}>{item.about}</p>
                                        </div>

                                        <button className={style.priceButton}>{item.button}</button>

                                        <div className={style.priceIncludes}>
                                            <p className={style.includesLabel}>{item.include}</p>
                                            <ul className={style.includesList}>
                                                {item.includes.map((itemdata, idx) => (
                                                    <li key={idx}>{itemdata}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>)
                    }

                </div>
            </div>
        </div>
    )
}

export default PlanPricing
